export const QtySelectComponent = {
  name: 'quickshop-qty-dropdown',
  template: `#quickshop-qty-dropdown`,
  props: ['label', 'position', 'options',  'handle', 'variantIds', 'variantPrices', 'selectedValue'],
  methods: {
    setSelectedQtyOption: function (qty) {
      this.$emit('qtyChange', qty);
    }
  },
  computed: {
    qtyValue() {
      return this.selectedValue;
    },
  },
};
